module.exports = __webpack_public_path__ + "b6bb945c7213c98b592271c52ffc0d01.svg";